import React from 'react';
import classNames from 'classnames';


interface contentLayoutProps {
    children: React.ReactElement,
    customClassName?: string,
}

function ContentLayout(props: contentLayoutProps) {

    const {customClassName} = props;

    return (
        <div className={classNames('content-container', customClassName ? customClassName : '')}>
            {props.children}
        </div>
    );

}

export default ContentLayout;

